import React from "react";
import styles from "./FreeNavbar.module.scss";
import { Nav, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";

const NavBar: React.FC = () => {
    return (
        <div className={styles.wrapper}>
            <Navbar className={styles.navBar} bg="light">
                <Link to="/" component={Navbar.Brand}>
                    Rend A Hand
                </Link>
                <Nav>
                    <Link to="/" component={Nav.Link}>
                        Home
                    </Link>
                    <Link to="/welcome/login" component={Nav.Link}>
                        Login
                    </Link>
                </Nav>
                <Navbar.Toggle />
            </Navbar>
        </div>
    );
};

export default NavBar;
